import { FC } from 'react';
import { TripType } from '../../services/tripType';
import { ToggleButton } from '../ToggleButton';
import { TripTypeIcon } from '../TripTypeIcon';
import styles from './TripTypeButton.module.css';
import { useIntl } from 'react-intl';

interface TripTypeButtonProps {
  tripType: TripType;
  onClick: (tripType: TripType) => void;
  active?: boolean;
}

export const TripTypeButton: FC<TripTypeButtonProps> = ({
  tripType,
  active,
  onClick,
}) => {
  const { $t } = useIntl();
  return (
    <ToggleButton
      className="capitalize"
      active={active}
      onClick={() => onClick(tripType)}
    >
      <TripTypeIcon className={styles.icn} tripType={tripType} />{' '}
      {$t({ id: `Trip.Type.${tripType}` })}
    </ToggleButton>
  );
};
